import { render } from "./management.cattle.io.fleetworkspace.vue?vue&type=template&id=3b4a22f0&scoped=true"
import script from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"

import "./management.cattle.io.fleetworkspace.vue?vue&type=style&index=0&id=3b4a22f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4a22f0"]])

export default __exports__